
import "@sparta.home-loans.modules/engagement-nl-module/dist/styles.css"
import "@sparta.home-loans.modules/overview-accordion-nl-module/dist/styles.css"
import "@sparta.home-loans.modules/rates-table-nl-module/dist/styles.css"
import "@sparta.home-loans.modules/navigator-nl-module/dist/styles.css"
import "@sparta.home-loans.modules/page-level-nl-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import ampTriggerVideoUtility from "@sparta.global.utilities/amp-trigger-video-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import jsUtility from "@sparta.home-loans.utilities/js-utility/dist/es6.js"

import "@sparta.home-loans.modules/engagement-nl-module/dist/es6.js"
import "@sparta.home-loans.modules/overview-accordion-nl-module/dist/es6.js"
import "@sparta.home-loans.modules/rates-table-nl-module/dist/es6.js"
import "@sparta.home-loans.modules/navigator-nl-module/dist/es6.js"
import "@sparta.home-loans.modules/page-level-nl-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.home-loans.modules/power-footer-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/home-loans-power-footer-module-es6" */ "@sparta.home-loans.modules/power-footer-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/home-loans-power-footer-module-styles" */ "@sparta.home-loans.modules/power-footer-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.home-loans.modules/header-links-module",
      loader: function() { return Promise.all([
      import( /* webpackChunkName: "spa-assets/on-demand/home-loans-header-links-module-es6" */ "@sparta.home-loans.modules/header-links-module/dist/es6.js" ),import( /* webpackChunkName: "spa-assets/on-demand/home-loans-header-links-module-styles" */ "@sparta.home-loans.modules/header-links-module/dist/styles.css" )
]);
      }
      },
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  jcrs: [
    {
      name: "site/home-loans/module-specific/power-footer/en/power-footer.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-home-loans-module-specific-power-footer-en-power-footer.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/5EC36E03/build/sit1a_h_w/site/mortgage/spa-assets/data/site-home-loans-module-specific-power-footer-en-power-footer-en-T1772567849209.json" )}
    },
    {
      name: "site/home-loans/module-specific/header-links/en/header-links.json",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/jcrs/site-home-loans-module-specific-header-links-en-header-links.json" */ "file:///apps/wt/webtools/webtools_build_server/tmp/5EC36E03/build/sit1a_h_w/site/mortgage/spa-assets/data/site-home-loans-module-specific-header-links-en-header-links-en-T1772567849209.json" )}
    }
  ]
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
  console.log('after - execute boot functions')
})();
